import { useNavigate } from 'react-router-dom';

import Tab from 'components/Common/Tab';
import routes from 'constants/routes';

type WalletSection = 'giving' | 'invoices';

/** Switch between Wallet destinations: Giving Basket (1) and Invoices (2). */
export default function WalletSectionTabs({ current }: { current: WalletSection }) {
    const navigate = useNavigate();
    return (
        <Tab
            tabs={[
                { value: 'giving', label: 'Giving Basket' },
                { value: 'invoices', label: 'Invoices' },
            ]}
            tabValue={current}
            setTabValue={(value: WalletSection) => {
                if (value === 'invoices') {
                    navigate(routes.invoices.list);
                    return;
                }
                navigate(routes.wallet.givingBasket);
            }}
        />
    );
}
